import { gql } from 'apollo-boost';
import { ADMIN_CONVERSATION_FRAGMENT } from '../fragments/admin-conversation-fragment';

export const GET_ADMIN_CONVERSATIONS = gql`
  ${ADMIN_CONVERSATION_FRAGMENT}
  query AdminConversations(
    $senderSearch: String
    $sortByUnreadMessages: Boolean
    $sortByLastMessageSent: Boolean
    $first: Int
    $after: String
  ) {
    admin_conversations(
      senderSearch: $senderSearch
      sortByUnreadMessages: $sortByUnreadMessages
      sortByLastMessageSent: $sortByLastMessageSent
      first: $first
      after: $after
    ) {
      nodes {
        ...adminConversationFragment
      }
      pageInfo {
        hasNextPage
        startCursor
        hasPreviousPage
        endCursor
      }
    }
  }
`;
